export default __webpack_public_path__ + "static/media/plus-black.9cebe731.svg";